/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Divider, Fade, Grid, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import './HeaderNotif.css';
import notificationIcon from '../../../assets/images/notificationIcon.svg';
import NotificationViewModalController from '../../Modals/Notification/NotificationViewModalController';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { formatTimeDifference } from '../../helper';

interface ModalProps {
  isOpen?: boolean;
  onCloseModal: any;
  HeaderNotifData: any;
  calltoupdateread: any;
}

const HeaderNotifPresenter = ({
  onCloseModal,
  HeaderNotifData,
  calltoupdateread,
}: ModalProps) => {
  const { t, i18n } = useTranslation();
  const handleViewAll = () => {
    navigate({ pathname: '/empNotification' });
    onCloseModal();
  };

  const [openModal, setOpenModal] = useState(false);
  const [ViewNotiData, setViewNotiData] = useState();
  const navigate = useNavigate();

  const handleViewNotification = (data: any) => {
    setOpenModal(true);
    setViewNotiData(data);
  };

  return (
    <>
      <Modal
        open={true}
        disableAutoFocus
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={onCloseModal}
      >
        <Fade in={true}>
          <Box
            className={i18n.language == 'en' ? 'Box1-Modal' : 'Box1-Modal_rtl'}
          >
            <Grid container style={{ padding: '10px' }}>
              <Grid item style={{ flexGrow: '1' }}>
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '0.9em',
                    paddingLeft: '1.5em',
                    paddingTop: '1.5em',
                    fontWeight: 'bold',
                  }}
                >
                  {t('Notifications')}
                </Typography>
                <Typography
                  style={{
                    color: '#8F95B2',
                    fontFamily: 'Lato',
                    paddingLeft: '2em',
                    paddingTop: '0.3em',
                    marginBottom: '1em',
                  }}
                  sx={{
                    fontSize: '0.7em',
                    paddingLeft: '1.4em',
                  }}
                >
                  {`${t('You have')} ${HeaderNotifData.length} ${t(
                    'messages',
                  )}`}
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  marginTop: '1.5em',
                }}
              >
                <Button
                  style={{
                    borderRadius: '1em',
                    fontSize: '0.6em',
                    fontFamily: 'Lato',
                    color: '#7C0E6F',
                    textTransform: 'capitalize',
                    border: '1px dashed #7C0E6F',
                    backgroundColor: '#7C0E6F1A',
                  }}
                  onClick={() => {
                    handleViewAll();
                  }}
                >
                  {t('View All')}
                </Button>
              </Grid>
            </Grid>

            <Divider />
            {_.map(HeaderNotifData, function (notification) {
              const time = formatTimeDifference(notification?.created_at);

              const is_read = notification?.read_at == 1 ? true : false;

              return (
                <div
                  onClick={() => {
                    handleViewAll();
                  }}
                >
                  <Grid
                    container
                    style={{
                      marginRight: '10px',
                      marginTop: '2px',
                      backgroundColor: is_read ? '#FFFFFF' : '#5E81F419',
                      paddingLeft: '1.5em',
                      paddingTop: '1em',
                      paddingBottom: '1em',
                      paddingRight: '0.6em',
                    }}
                  >
                    <Grid item xs={2} style={{ alignSelf: 'center' }}>
                      <img src={notificationIcon} width={18} height={18} />
                    </Grid>
                    <Grid item xs={7}>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontFamily: 'Lato',
                          color: '#081735',
                          fontWeight: 'bold',
                        }}
                      >
                        {notification.type}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: '10px',
                          fontFamily: 'Lato',
                          color: '#8F95B2',
                          fontWeight: 'bold',
                        }}
                      >
                        {notification.subject
                          ? notification.subject
                          : notification.notifiable_type}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      style={{
                        alignSelf: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className="las la-clock"
                        style={{
                          color: '#8F95B2',
                          height: '0.1em',
                          width: '0.1em',
                        }}
                      ></i>
                      <Typography
                        sx={{
                          fontSize: '0.6em',
                          fontFamily: 'Lato',
                          color: '#8F95B2',
                          marginLeft: i18n.language == 'en' ? '2em' : '',
                          marginRight: i18n.language == 'ar' ? '4em' : '',
                        }}
                        variant="caption"
                      >
                        {time}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider />
                </div>
              );
            })}
          </Box>
        </Fade>
      </Modal>
      {openModal && (
        <NotificationViewModalController
          isModalOpen={openModal}
          closeModal={() => {
            setOpenModal(false);
            calltoupdateread(ViewNotiData);
          }}
          notificationViewData={ViewNotiData}
          trans={t}
        />
      )}
    </>
  );
};
export default HeaderNotifPresenter;
